import React, { useState } from "react";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { peicarLogoSVG } from "../../Assets/Images";
import { ModalGralCss } from "./ModalGral.css";
import { Tooltip } from "primereact/tooltip";

export default function ModalGral({ setShowModal, showModal, isError, data, admin, toast }) {

  const [copied, setCopied] = useState(false);

  const copyToClipboard = () => {
    navigator.clipboard.writeText(data.current);
    setCopied(true);
    toast.current.show({ severity: "success", summary: "Copiado al portapapeles", life: 2000 });
    setTimeout(() => setCopied(false), 2000); // Mensaje temporal de "Copiado"
  };

  return (
    <div css={ModalGralCss()}>
      <div className="Modal card flex justify-content-center"
        style={{ boxShadow: "1px 1px 1px black" }}>
        {isError ?
          <Dialog
            visible={true}
            modal
            closable={false} // Habilita el botón de cierre
            onHide={() => setShowModal(false)}
            draggable={false}
            style={{ width: "50vw", opacity: 1, borderRadius: "25px" }}
            breakpoints={{ "960px": "75vw", "641px": "100vw" }}
            header={
              <div className="header-with-image flex mb-0">
                <h2
                >
                  Vaya, algo salió mal
                </h2>
              </div>
            }
          >
            <p
              className="content m-0"
              style={{
                fontStyle: "normal",
                fontWeight: 500,
                lineHeight: "166.667%",
                fontSize: "calc(0.4rem + 0.9vw)",
              }}
            >
              {data}
            </p>

            <div style={{ display: "flex", justifyContent: "flex-end", width: "100%" }}>
              <Button
                label="Aceptar"
                onClick={() => setShowModal(false)}
                className="p-button-raised p-button-rounded"
                style={{
                  background: "#34C6F1",
                  color: "white",
                  fontWeight: 600,
                  fontSize: "calc(0.4rem + 0.9vw)",
                  marginTop: "1rem",
                  border: "none",
                  cursor: "pointer",
                  width: "100%",
                }}
              />
            </div>
          </Dialog>
          : admin ?
            <Dialog
              // header="Revisa tu correo"
              visible={true}
              onCLose={() => setShowModal(false)}
              closable={true} // Habilita el botón de cierre
              onHide={() => setShowModal(false)} // Cierra el modal
              draggable={false}
              style={{
                width: "50vw",
                '& .p-dialog-header-icons': {
                  display: "none",
                }

              }}
              breakpoints={{ "960px": "75vw", "641px": "100vw" }}
              dismissableMask={true} // Permite cerrar al hacer clic fuera del modal

              header={
                <div className="header-with-image flex mb-0">
                  {/* <img
             src={peicarLogoSVG}
             alt="Descripción de la imagen"
             width={80}
             className="mr-5"
           /> */}
                  <h2
                    style={{
                      background:
                        "linear-gradient(90deg, #34C6F1 6.22%, #1FDD8F 77.34%)",
                      WebkitBackgroundClip: "text",
                      backgroundClip: "text",
                      WebkitTextFillColor: "transparent",
                    }}
                  >
                    Contraseña cambiada
                  </h2>
                </div>
              }
            >
              <p
                style={{
                  background:
                    "linear-gradient(90deg, #34C6F1 6.22%, #1FDD8F 77.34%)",
                  WebkitBackgroundClip: "text",
                  backgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                  marginBottom: "1rem",
                  fontSize: "calc(0.6rem + 0.9vw)",
                }}
              >
                ! Tu nueva contraseña ha sido guardada !

              </p>
              <br />
              <p
                className="content m-0 flex items-center gap-2"
                onClick={copyToClipboard}
                style={{
                  fontStyle: "normal",
                  fontWeight: 500,
                  lineHeight: "166.667%",
                  fontSize: "calc(0.4rem + 0.9vw)",
                  alignItems: "center",
                  cursor: "pointer",
                }}
              >
                Tu nueva contraseña es{" "}
                <span
                  style={{
                    backgroundColor: "#E3F2FD", // Color de fondo sutil
                    padding: "0.2rem 0.6rem",
                    borderRadius: "8px",
                    fontWeight: "bold",
                    fontSize: "1rem",
                    color: "#0D47A1", // Azul fuerte para destacar
                  }}
                >
                  {data.current}
                </span>
                <Button
                  icon="pi pi-copy"
                  className="p-button-text p-button-sm"
                  // onClick={copyToClipboard}
                  data-pr-tooltip={copied ? "¡Copiado!" : "Copiar"}
                />
                <Tooltip target=".p-button" position="top" />
              </p>
              <br />
              <p
                style={{
                  fontStyle: "normal",
                  fontWeight: 500,
                  lineHeight: "166.667%",
                  fontSize: "calc(0.4rem + 0.9vw)",
                  color: "#FF0000",
                }}
              >
                Tines que guardarla en un lugar seguro.
              </p>
            </Dialog>
            :
            <Dialog
              // header="Revisa tu correo"
              visible={true}
              modal
              closable={false} // Habilita el botón de cierre
              onHide={() => setShowModal(false)}
              draggable={false}
              style={{ width: "50vw" }}
              breakpoints={{ "960px": "75vw", "641px": "100vw" }}
              header={
                <div className="header-with-image flex mb-0">
                  {/* <img
                src={peicarLogoSVG}
                alt="Descripción de la imagen"
                width={80}
                className="mr-5"
              /> */}
                  <h2
                    style={{
                      background:
                        "linear-gradient(90deg, #34C6F1 6.22%, #1FDD8F 77.34%)",
                      WebkitBackgroundClip: "text",
                      backgroundClip: "text",
                      WebkitTextFillColor: "transparent",
                    }}
                  >
                    Revisa tu correo
                  </h2>
                </div>
              }
            >
              <p
                style={{
                  // background:
                  //   "linear-gradient(90deg, #34C6F1 6.22%, #1FDD8F 77.34%)",
                  // WebkitBackgroundClip: "text",
                  // backgroundClip: "text",
                  // WebkitTextFillColor: "transparent",
                  marginBottom: "1rem",
                  fontSize: "calc(0.6rem + 0.9vw)",
                  color: "#21588C",
                  fontWeight: 600,
                }}
              >
                ! Ya puedes cerrar esta ventana !
              </p>
              <p
                className="content m-0"
                style={{
                  fontStyle: "normal",
                  fontWeight: 500,
                  lineHeight: "166.667%",
                  fontSize: "calc(0.4rem + 0.9vw)",
                }}
              >
                Te enviamos un correo electrónico para confirmar tu cuenta. Revisa tu bandeja de entrada y sigue las instrucciones.

              </p>
              <br />

              <p style={{ fontStyle: "normal", fontWeight: 500, lineHeight: "166.667%", fontSize: "calc(0.4rem + 0.9vw)" }}>
                Si no lo encuentras en tu bandeja de entrada, asegúrate de
                revisar la carpeta de spam.
              </p>
            </Dialog>}
      </div>
    </div>
  );
}
